import { getMakeupHairApiBaseUrl } from '../../makeuphair/utils/apiConfig';
import { kioskAuthHeaders } from '../../makeuphair/utils/kioskAuthHeaders';
import { appendFranchiseScopeQueryToPath } from '../../shared/franchiseFlowAuth';

function beardBase() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/beard-styling`;
}

function withOrg(path) {
  return appendFranchiseScopeQueryToPath(path);
}

async function beardFetch(path, options = {}) {
  const res = await fetch(`${beardBase()}${withOrg(path)}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...kioskAuthHeaders({ 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || `Request failed (${res.status})`);
    err.code = data?.code;
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchBeardStyles() {
  return beardFetch('/styles');
}

export async function analyzeBeard(image, profile) {
  return beardFetch('/analyze', {
    method: 'POST',
    body: JSON.stringify({ image, profile }),
  });
}

export async function recommendBeardLooks(body = {}) {
  return beardFetch('/recommend', { method: 'POST', body: JSON.stringify(body) });
}

export async function generateBeardLook(body) {
  return beardFetch('/generate', { method: 'POST', body: JSON.stringify(body) });
}
